// Minimal dependency-free toast. Usage: toast("Saved"), toast("Failed", "error").
const COLORS = {
  success: { bg: "#ecfdf5", border: "#10b981", fg: "#065f46" },
  error: { bg: "#fef2f2", border: "#ef4444", fg: "#991b1b" },
  warning: { bg: "#fffbeb", border: "#f59e0b", fg: "#92400e" },
  info: { bg: "#eff6ff", border: "#3b82f6", fg: "#1e40af" },
}

function getStack() {
  let stack = document.getElementById("sf-toast-stack")
  if (!stack) {
    stack = document.createElement("div")
    stack.id = "sf-toast-stack"
    Object.assign(stack.style, {
      position: "fixed", top: "16px", right: "16px", zIndex: "20000",
      display: "flex", flexDirection: "column", gap: "8px", maxWidth: "380px",
    })
    document.body.appendChild(stack)
  }
  return stack
}

export function toast(message, type = "success", durationMs = 5000) {
  if (typeof document === "undefined") return
  const c = COLORS[type] || COLORS.info
  const el = document.createElement("div")
  el.setAttribute("role", type === "error" ? "alert" : "status")
  el.textContent = message
  Object.assign(el.style, {
    background: c.bg, color: c.fg, borderLeft: `4px solid ${c.border}`,
    padding: "10px 14px", borderRadius: "8px", fontSize: "13px", lineHeight: "1.4",
    boxShadow: "0 6px 20px rgba(15,23,42,.15)", whiteSpace: "pre-line", cursor: "pointer",
  })
  el.onclick = () => el.remove()
  getStack().appendChild(el)
  setTimeout(() => el.remove(), durationMs)
}

export default toast
